/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react";
import { ALERT_FAIL, ALERT_SUCCESS, CVE_DIRECCION, CVE_ESTATUS_TERCERO } from "../../app/constantes"
import DireccionComponent from "../generales/direccionComponent"
import { direccionForm } from "../../app/forms/registro/direccion";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as InfoIcon } from '../../assets/icons/info.svg';
import { ReactComponent as DocIcon } from '../../assets/icons/file.svg';
import { fillForm, formatForm, validateForm } from "../../app/commons";
import { postDireccionTercero, putDireccionEntidad } from "../../services/entidad";
import { catalogosServiceState } from "../../slices/catalogosServiceSlice";
import { appState, setAlert, setLoading } from "../../slices/appSlice";
import InputComp from "../generales/inputComponent";
import { datosFiscalesTerceroForm } from "../../app/forms/cobros/datosFiscales";
import { pagosState } from "../../slices/pagosSlice";
import { getDocumentosTerceros, postFacturacionTerceros, putCambioEstatusTercero, putFacturacionTerceros } from "../../services/cobro";
import DocumentoTercero from "../generales/documento-tercero";
import machote from '../../assets/CARTA CAMBIO DE DATOS FISCALES.pdf';
import Image from '../../assets/regimen_ex.jpeg';


export default function ModalDatosFiscalesTerceros({ setModalData, modalData, tipoDireccion, refreshData, idEntidad }) {
    const dispatch = useDispatch()

    const appSt = useSelector(appState);
    const pagosSt = useSelector(pagosState);
    const catalogosSt = useSelector(catalogosServiceState);

    const [form, setForm] = useState(JSON.parse(JSON.stringify(datosFiscalesTerceroForm)));
    const [formDireccion, setFormDireccion] = useState(JSON.parse(JSON.stringify(direccionForm)));
    const [selected, setSelected] = useState(null)
    const [documents, setDocuments] = useState(null)
    const [rejectedDocs, setRejectedDocs] = useState(null)
    const [canValidate, setCanValidate] = useState(false)
    const [rejectPass, setRejectPass] = useState(false)
    const [onlyView, setOnlyView] = useState(false)
    const [rejectedForm, setRejectedForm] = useState(null)
    const [rejectedDir, setRejectedDir] = useState(null)

    const closeModal = () => {
        setForm(JSON.parse(JSON.stringify(datosFiscalesTerceroForm)))
        setFormDireccion(JSON.parse(JSON.stringify(direccionForm)))
        setSelected(null)
        setRejectPass(false)
        setDocuments(null)
        setRejectedDocs(null)
        setCanValidate(false)
        setOnlyView(false)
        setRejectedForm(null)
        setRejectedDir(null)
        refreshData()
        setModalData({
            show: false,
            data: null
        })
    }

    const handleSubmit = async () => {
        const validDir = validateForm(formDireccion)
        const formatedDir = formatForm(formDireccion)
        const validForm = validateForm(form)
        if (validDir.length === 0 && validForm.length === 0) {
            const formated = formatForm(form)
            let resp 
            try {
                dispatch(setLoading(true))
                if (selected) {
                    const respDir = await putDireccionEntidad({...appSt.serviceData, idDireccion: selected.idDireccionEntidad}, {
                        idPais: formatedDir.idPais,
                        calle: formatedDir.calle,
                        numeroExterior: formatedDir.numeroExterior,
                        numeroInterior: formatedDir.numeroInterior,
                        idCodigoPostal: formatedDir.idCodigoPostal,
                        idEntidad: idEntidad ? idEntidad : pagosSt.currentConvocatoria.idEntidad,
                    })

                    resp = await putFacturacionTerceros({
                        ...appSt.serviceData,
                        idPersonaTercero: selected.idPersonaTercero,
                        body: {
                            idEstatusFacturaTercero: 1,
                            idEntidad: idEntidad ? idEntidad : pagosSt.currentConvocatoria.idEntidad,
                            idRegimenFiscal: formated.idRegimenFiscal,
                            idDireccionEntidad: respDir.payload.id,
                            idUsoCfdi: formated.idUsoCfdi,
                            observacionFacturaTercero: "",
                            rfc: formated.rfc,
                            razonSocialTercero: formated.razonSocial,
                            nombre: formated.nombre,
                            apellidoPaterno: formated.apellidoPaterno,
                            apellidoMaterno: formated.apellidoMaterno,
                            telefono: formated.telefono,
                            celular: formated.celular,
                            email: formated.correoElectronico,
                            lada: formated.lada,
                        }
                    })
                    
                } else {
                    const respDir = await postDireccionTercero({
                        ...appSt.serviceData,
                        body: {
                            idPais: formatedDir.idPais,
                            calle: formatedDir.calle,
                            numeroExterior: formatedDir.numeroExterior,
                            numeroInterior: formatedDir.numeroInterior,
                            idTipoDireccion: tipoDireccion.idTipoDireccion,
                            idCodigoPostal: formatedDir.idCodigoPostal,
                            idEntidad: idEntidad ? idEntidad : pagosSt.currentConvocatoria.idEntidad,
                        }
                    })

                    resp = await postFacturacionTerceros({
                        ...appSt.serviceData,
                        body: {
                            idEstatusFacturaTercero: 1,
                            idEntidad: idEntidad ? idEntidad : pagosSt.currentConvocatoria.idEntidad,
                            idRegimenFiscal: formated.idRegimenFiscal,
                            idDireccionEntidad: respDir.payload.idDireccionEntidad,
                            idUsoCfdi: formated.idUsoCfdi,
                            observacionFacturaTercero: "",
                            rfc: formated.rfc,
                            razonSocialTercero: formated.razonSocial,
                            nombre: formated.nombre,
                            apellidoPaterno: formated.apellidoPaterno,
                            apellidoMaterno: formated.apellidoMaterno,
                            telefono: formated.telefono,
                            celular: formated.celular,
                            email: formated.correoElectronico,
                            lada: formated.lada,
                        }
                    })
                }

                if (resp && resp.payload) {
                    setSelected(resp.payload)
                }

                if (selected) {
                    await sendToValidate(resp.payload)
                }


                dispatch(setLoading(false))

            } catch (error) {
                console.error(error)
                dispatch(setLoading(false))
                dispatch(setAlert({
                    show: true,
                    message: 'Error al guardar información',
                    type: ALERT_FAIL
                }))
            }
        } else {
            dispatch(setAlert({
                show: true,
                message: 'Favor de llenar todos los campos requeridos',
                type: ALERT_FAIL
            }))
        }
    }

    const populateData = async () => {
        const clone = fillForm(form, modalData.data)
        clone.rfc.value = modalData.data.rfcTerceros
        clone.razonSocial.value = modalData.data.razonSocialTercero
        clone.idRegimenFiscal.value = modalData.data.idRegimenFiscal
        setForm(clone) 
        if (modalData.data.cveEstatusFacturaTercero === CVE_ESTATUS_TERCERO.rechazada) {
            setRejectedForm(JSON.stringify(clone))
        }
        
    }
    
    const formatDocs = async () => {
        
        let array = []
        const valid = []
        let resp = null

        if (selected) {
            resp = await getDocumentosTerceros({
                ...appSt.serviceData,
                idPersonaTercero: selected.idPersonaTercero
            })
        }
        
        catalogosSt.documentosTerceros.forEach((item) => {
            let exist = null
            if (selected && resp && resp.payload && resp.payload.length > 0) {
                exist = resp.payload.find((i) => i.idDocumentoCemefi === item.idDocumentoCemefi)
                if (exist) {
                    valid.push(exist)
                }
                array.push({
                    ...item,
                    idContent: exist ? exist.idContent : null,
                    idDocumentoCobroTercero: exist ? exist.idDocumentoCobroTercero : null,
                    idPersonaTercero: exist ? exist.idPersonaTercero : null,
                })
            } else {
                array.push({
                    ...item, 
                })

            }
        })
        setCanValidate(catalogosSt.documentosTerceros.length === valid.length)
        if (modalData.data && modalData.data.cveEstatusFacturaTercero === CVE_ESTATUS_TERCERO.rechazada && !rejectedDocs) {
            setRejectedDocs(array)
        }
        setDocuments(array)
    }

    const sendToValidate = async (item) => {
        try {
            await putCambioEstatusTercero({
                ...appSt.serviceData,
                idPersonaTercero: item.idPersonaTercero,
                body: {
                    cveEstatusFacturaTercero: CVE_ESTATUS_TERCERO.enRevision
                }
            })
            dispatch(setAlert({
                show: true,
                message: 'Registro enviado a revisión',
                type: ALERT_SUCCESS
            }))
            closeModal()
        } catch (error) {
            console.error(error)
            dispatch(setAlert({
                show: true,
                message: 'Error al cambiar estatus',
                type: ALERT_FAIL
            }))
        }
    }

    const customTool = (tool) => {
        return (<div className="custom-tool">
                <p>{tool}</p>
                <img src={Image} alt="razon-social" />
        </div>)
      }

    useEffect(() => {
        setSelected(modalData.data)
        if (modalData.data) {
            populateData()
        }
    }, [modalData.data])
    
    useEffect(() => {
        formatDocs()
        if (selected) {
            setOnlyView(selected.cveEstatusFacturaTercero === CVE_ESTATUS_TERCERO.enRevision || selected.cveEstatusFacturaTercero === CVE_ESTATUS_TERCERO.confirmada)
        }
    }, [selected])

    useEffect(() => {
        if (modalData.data && modalData.data && modalData.data.cveEstatusFacturaTercero === CVE_ESTATUS_TERCERO.rechazada && formDireccion.idCodigoPostal.value && !rejectedDir) {
            setRejectedDir(JSON.stringify(formDireccion))
        }
    }, [formDireccion])

    useEffect(() => {
        if (modalData.data && modalData.data.cveEstatusFacturaTercero === CVE_ESTATUS_TERCERO.rechazada && rejectedForm && rejectedDir) {
            const formValue = JSON.stringify(form)
            const dirValue = JSON.stringify(formDireccion)
            const equalDir = dirValue === rejectedDir
            const equalForm = formValue === rejectedForm
            const equalDocs = JSON.stringify(documents) === JSON.stringify(rejectedDocs)
            setRejectPass(!equalForm || !equalDir || !equalDocs)
        } else {
            setRejectPass(true)
        }
    }, [form, formDireccion, rejectedForm, rejectedDir, documents])

    return (
        <div className={modalData.show ? 'modal-wrapper active' : 'modal-wrapper'}>
            <div className="modal modal-datos-fiscales">
                <div className="head">
                    <h3>Datos Fiscales</h3>
                    <button onClick={closeModal}>
                        x
                    </button>
                </div>
                <div className="content">
                    <div className="tip">
                        <InfoIcon />
                        <p>Una vez validados los datos fiscales, la factura será emitida y no habrá cancelaciones. <br></br> Al modificar la dirección fiscal los datos se guardaran en automatico al seleccionar el boton de continuar</p>
                    </div>
                    {selected && selected.observacionFacturaTercero && (
                        <div className="tip">
                            <InfoIcon />
                            <p>{selected.observacionFacturaTercero}</p>
                        </div>
                    )}
                    <DireccionComponent disabled={onlyView} aviso={null} direccion={selected} cveDireccion={CVE_DIRECCION.fiscal} form={formDireccion} setForm={setFormDireccion} isFiscal={true}/>
                    <div className="card-registro">
                        <div className="head">
                            <h4>Datos Fiscales</h4>
                        </div>
                        <div className="two-col content">
                            <InputComp disabled={onlyView} label="RFC" name="rfc" type="upper" form={form} setForm={setForm} validation={'^([A-ZÑ\\x26]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])((-)?([A-Z\\d]{3})))?$|!( $)'}/>
                            <InputComp disabled={onlyView} label="Razón social" name="razonSocial" type="upper" form={form} setForm={setForm} />
                            {catalogosSt.usoCfdi &&
                                <InputComp disabled={onlyView} label="Uso CFDI" name="idUsoCfdi" type="select" form={form} setForm={setForm} catalogos={catalogosSt.usoCfdi} catalogoValue={'idUsoCfdi'} catalogoLabel={'descUsoCfdi'} secundaryLabel={'cveUsoCfdi'}/>
                            }
                            {catalogosSt.regimen &&
                                <InputComp customTool={customTool} disabled={onlyView} label="Regimen fiscal" name="idRegimenFiscal" type="select" form={form} setForm={setForm} catalogos={catalogosSt.regimen} catalogoValue={'idRegimenFiscal'} catalogoLabel={'descRegimenFiscal'} secundaryLabel={'cveRegimenFiscal'} />
                            }
                        </div>
                    </div>
                    <div className="card-registro">
                        <div className="head">
                            <h4>Contacto Principal</h4>
                        </div>
                        <div className="two-col content">
                            <InputComp disabled={onlyView} label="Nombre" name="nombre" type="upper" form={form} setForm={setForm} />
                            <InputComp disabled={onlyView} label="Apellido paterno" name="apellidoPaterno" type="upper" form={form} setForm={setForm} />
                            <InputComp disabled={onlyView} label="Apellido materno" name="apellidoMaterno" type="upper" form={form} setForm={setForm} />
                            <InputComp disabled={onlyView} max="10" validation="phone" label="Teléfono" name="telefono" type="number" form={form} setForm={setForm} />
                            <InputComp disabled={onlyView} max='10' validation="cel" label="Teléfono celular" name="celular" type="number" form={form} setForm={setForm} />
                            <InputComp disabled={onlyView} label="Correo electrónico" name="correoElectronico" type="lower" form={form} setForm={setForm} validation={"mail"} />
                        </div>
                    </div>
                    {selected && (
                        <div className="documents-terceros">
                            <div className="documents-wrapper">
                                <h3>Documentos requeridos</h3>
                                <div className="content">
                                    <div className="actions">
                                    </div>
                                    <div className="documents">
                                        <div className="document uploaded">
                                            <div className="doc-content">
                                                <div className="head">
                                                    <p>Descargar Solicitud</p>
                                                </div>
                                                <DocIcon />
                                            </div>
                                            <div className="actions">
                                                <a href={machote} download={"CARTA CAMBIO DE DATOS FISCALES"} target='_blank' rel="noreferrer">Descargar</a>
                                            </div>
                                        </div>
                                        {documents && documents.map((doc, index) => {
                                            return  <DocumentoTercero 
                                            onlyView={onlyView}
                                            doc={doc} 
                                            key={index} 
                                            refreshData={formatDocs}
                                            tercero={selected}/>
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <div className="actions">
                    <button onClick={closeModal}>Cerrar</button>
                    {!onlyView && !selected && (<>
                        <button onClick={handleSubmit}>Guardar</button>
                    </>)}
                    {!onlyView && selected && (<>
                        <button disabled={!canValidate || !rejectPass} onClick={handleSubmit}>Guardar/Enviar a validar</button>
                    </>)}
                </div>
            </div>
        </div>
    )
}